/**
 * Csv Schema of AdminConfig
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {AdminConfig} from '@/model/resource/AdminConfig'

/* TODO: review generated schema */
export class CsvAdminConfigSchema extends Schema {
  readonly name = 'CsvAdminConfig'

  readonly fieldSet: FieldSet<AdminConfig> = {
    idConfigPk: schema => schema.model.idConfigPk,
    autorizarMesmoVencido: schema =>
      Helper.bool(schema.model.autorizarMesmoVencido),
    senhaApp: schema => schema.model.senhaApp,
    senhaPainel: schema => schema.model.senhaPainel,
    indiqueUmAmigo: schema => schema.model.indiqueUmAmigo,
    boasVindas: schema => schema.model.boasVindas,
  }
}
